<template>
  <div>
    <div v-if="dialogVisible" class="add-seats-overlay">
      <div class="add-seats-dialog">
        <button class="add-seats-close" type="button" @click="handleCancel">
          ×
        </button>

        <section class="add-seats-main">
          <button class="add-seats-panel-close" type="button" @click="handleCancel">
            ×
          </button>

          <h2 class="add-seats-title">新增席位</h2>
          <div class="add-seats-divider"></div>

          <p class="add-seats-label">选择商品</p>
          <div class="add-seats-plan-card">
            <div class="add-seats-plan-name">
              {{ previewPlanTitle }}· {{ displayPeriodLabel }}
            </div>
            <p
              v-if="!isMonthlyPeriod"
              class="add-seats-plan-desc"
            >
              剩余{{ displayRemainingMonths }}个月+1个月（1个月：购买后立即发放本周期积分）
            </p>
     
            <div class="add-seats-plan-price">
              ¥{{ displayPerSeatPrice}} <span>{{ displayPriceUnit }}</span>
              <em v-if="displayOriginalPerSeatPrice" style="color: #8b93a7 !important;font-weight: normal !important;">¥{{ displayOriginalPerSeatPrice }}</em>
            </div>
            <p class="add-seats-plan-month">
              {{ displayMonthlyAvgPrice }}元/席位/月
            </p>
          </div>

          <div class="add-seats-count-head">
            <span>席位数量（支持 1-{{ maxAddSeats }} 人）</span>
          </div>
          <div class="add-seats-counter">
            <button
              type="button"
              :disabled="addSeats <= 1 || orderLoading || paymentStarted"
              @click="updateAddSeats(addSeats - 1)"
            >
              -
            </button>
            <strong>
              <input
                :value="addSeats"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                :disabled="orderLoading || paymentStarted"
                @input="handleAddSeatsInput"
                @blur="handleAddSeatsBlur"
                @keydown.enter.prevent="$event.target.blur()"
              />
              <span>席位</span>
            </strong>
            <button
              type="button"
              :disabled="addSeats >= maxAddSeats || orderLoading || paymentStarted"
              @click="updateAddSeats(addSeats + 1)"
            >
              +
            </button>
          </div>

          <div class="add-seats-summary">
            <div class="add-seats-summary-row">
              <span>生效时间</span>
              <strong>立即生效</strong>
            </div>
            <div class="add-seats-summary-row">
              <span>团队剩余有效期</span>
              <strong>{{ displayRemainingDays }}天</strong>
            </div>
            <div class="add-seats-summary-row">
              <span>新增席位数量</span>
              <strong>{{ addSeats }} 席位</strong>
            </div>
            <div class="add-seats-summary-row">
              <span>本周期单席位积分</span>
              <strong>{{ formatNumber(unitCurrentMonthCredits) }} 积分</strong>
        
            </div>
            <div class="add-seats-summary-row">
              <span>本周期新增席位总积分</span>
              <strong>{{ formatNumber(preview && preview.currentMonthCredits) }} 积分</strong>
            </div>
            <div
              v-if="displayDiscountAmount"
              class="add-seats-summary-row add-seats-discount-row"
            >
              <span style="color: #fff;">优惠金额</span>
              <strong>-¥{{ displayDiscountAmount }}</strong>
            </div>
            <div class="add-seats-pay-row">
              <span>应付金额</span>
              <div class="add-seats-pay-amount-wrap">
                <strong>¥{{ displayPayAmount }}</strong>
                <em v-if="displayOriginalTotalPrice" style="color: #fff !important;margin-top: 0.14286rem;">原价 ¥{{ displayOriginalTotalPrice }}</em>
              </div>
            </div>
          </div>
        </section>

        <section class="add-seats-pay">
          <template v-if="!paymentStarted">
            <div class="add-seats-pay-amount-label">应付金额</div>
            <div class="add-seats-pay-amount">¥{{ displayPayAmountWithDecimal }}</div>
            <div class="add-seats-pay-seats">{{ displayAddSeats }} 席位</div>
            <button
              class="add-seats-go-pay-button"
              type="button"
              :disabled="previewLoading || orderLoading || !preview"
              @click="handleGoPay"
            >
              {{ goPayButtonText }}
            </button>
            <!-- <p class="add-seats-agreement">开通即代表同意《漫枢订阅协议》</p> -->
          </template>

          <template v-else>
            <div class="add-seats-expire" :class="{ 'is-expired': qrExpired }">
              {{ payExpireText }}
            </div>
            <div
              class="add-seats-qr"
              :class="{ 'is-expired': qrExpired, 'is-clickable': qrExpired }"
              @click="handleRefreshQr"
            >
              <img
                v-if="qrCodeImgUrl"
                class="add-seats-qr-image"
                :src="qrCodeImgUrl"
                alt=""
              />
              <div v-else class="add-seats-qr-placeholder">
                {{ qrPlaceholderText }}
              </div>
              <div v-if="qrExpired" class="add-seats-qr-expired">
                <i class="el-icon-refresh"></i>
                <span>二维码已过期,请刷新二维码</span>
              </div>
            </div>
            <div class="add-seats-pay-title">请扫码支付</div>

            <div class="add-seats-methods">
              <label class="add-seats-method">
                <input
                  v-model="paymentMethod"
                  type="radio"
                  value="alipay"
                  :disabled="previewLoading || orderLoading"
                  @change="handlePaymentMethodChange"
                />
                <span>支付宝</span>
              </label>
              <label class="add-seats-method">
                <input
                  v-model="paymentMethod"
                  type="radio"
                  value="wechat"
                  :disabled="previewLoading || orderLoading"
                  @change="handlePaymentMethodChange"
                />
                <span>微信</span>
              </label>
            </div>

            <button
              class="add-seats-paid-button"
              type="button"
              :disabled="previewLoading || orderLoading || payChecking || !outTradeNo || qrExpired"
              @click="handlePaid"
            >
              {{ paidButtonText }}
            </button>
            <!-- <p class="add-seats-agreement">开通即代表同意《漫枢订阅协议》</p> -->
          </template>
        </section>
      </div>
    </div>

    <subscription-pay-result-dialog
      :visible.sync="payResultVisible"
      @confirm="finalizePaySuccess"
    />
  </div>
</template>

<script>
import QRCode from "qrcode";
import bus from "@/bus.js";
import SubscriptionPayResultDialog from "@/views/subscription/SubscriptionPayResultDialog.vue";
import {
  MAX_SUBSCRIPTION_SEAT,
  formatPriceFromFen,
  getCycleLabel,
  isApiSuccess,
  periodTypeToCycle,
} from "@/utils/subscription";

const DEFAULT_PAY_EXPIRE_MINUTES = 15;
const PAY_EXPIRE_SECONDS = DEFAULT_PAY_EXPIRE_MINUTES * 60;

function createEmptyPaySession() {
  return {
    qrCodeImgUrl: "",
    outTradeNo: "",
    expireAt: 0,
  };
}

export default {
  name: "AddSeatsPayDialog",
  components: {
    SubscriptionPayResultDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    periodType: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
			unitCurrentMonthCredits: 0,
      addSeats: 1,
      paymentMethod: "alipay",
      preview: null,
      previewLoading: false,
      previewRequestId: 0,
      orderLoading: false,
      paymentStarted: false,
      payChecking: false,
      qrCodeImgUrl: "",
      outTradeNo: "",
      pollTimerId: null,
      countdownTimerId: null,
      remainingSeconds: PAY_EXPIRE_SECONDS,
      paySessions: {
        alipay: createEmptyPaySession(),
        wechat: createEmptyPaySession(),
      },
      payResultVisible: false,
      pendingSuccessType: "",
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    maxAddSeats() {
      return MAX_SUBSCRIPTION_SEAT;
    },
    previewPlanTitle() {
      const name = this.preview && this.preview.planName;
      return name || "企业版套餐";
    },
    normalizedPeriodType() {
      const source =
        this.preview && this.preview.periodType != null
          ? this.preview.periodType
          : this.periodType;
      const value = Number(source);
      return Number.isFinite(value) ? value : null;
    },
    isMonthlyPeriod() {
      return this.normalizedPeriodType === 1;
    },
    displayPeriodLabel() {
      if (this.preview && this.preview.periodLabel) {
        return this.preview.periodLabel;
      }
      if (this.normalizedPeriodType != null) {
        return getCycleLabel(periodTypeToCycle(this.normalizedPeriodType));
      }
      return "当前周期";
    },
    displayRemainingMonths() {
      return this.formatNumber(this.preview && this.preview.remainingMonths);
    },
		displayRemainingDays() {
			console.log(this.preview,'this.preview')
			return this.formatNumber(this.preview && this.preview.remainingDays);
		},
    displayCurrentSeats() {
      return this.formatNumber(this.preview && this.preview.currentSeats);
    },
    displayAddSeats() {
      return this.formatNumber((this.preview && this.preview.addSeats) || this.addSeats);
    },
    displayNewSeats() {
      return this.formatNumber(this.preview && this.preview.newSeats);
    },
		displayPerSeatPrice() {
			return formatPriceFromFen(this.preview && this.preview.perSeatPrice);
		},
    displayOriginalPerSeatPrice() {
      const pricePerSeat = Number(this.preview && this.preview.originalPricePerSeat);
      if (!Number.isFinite(pricePerSeat) || pricePerSeat <= 0) {
        return "";
      }
      return formatPriceFromFen(pricePerSeat);
    },
    displayPriceUnit() {
      return (this.preview && this.preview.priceUnit) || "";
    },
    displayPayAmount() {
			console.log(this.preview && this.preview.payAmount,'this.preview && this.preview.payAmount')
      return formatPriceFromFen(this.preview && this.preview.payAmount);
    },
    displayDiscountAmount() {
      const amount = Number(this.preview && this.preview.discountAmount);
      if (!Number.isFinite(amount) || amount <= 0) {
        return "";
      }
      return formatPriceFromFen(amount);
    },
    displayOriginalTotalPrice() {
      const pricePerSeat = Number(this.preview && this.preview.originalPricePerSeat);
      const seats = Number(
        (this.preview && this.preview.addSeats) || this.addSeats || 0,
      );
      if (
        !Number.isFinite(pricePerSeat) ||
        pricePerSeat <= 0 ||
        !Number.isFinite(seats) ||
        seats <= 0
      ) {
        return "";
      }
      return formatPriceFromFen(pricePerSeat * seats);
    },
    displayPayAmountWithDecimal() {
      const amount = Number((this.preview && this.preview.payAmount) || 0) / 100;
      return amount.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    displayMonthlyAvgPrice() {
      return formatPriceFromFen(this.preview && this.preview.monthlyAvgPrice, {
        decimal: true,
      });
    },
    qrPlaceholderText() {
      if (this.previewLoading || this.orderLoading) {
        return "支付二维码生成中";
      }
      return this.paymentMethod === "wechat" ? "微信扫码支付" : "支付宝扫码支付";
    },
    paidButtonText() {
      if (this.payChecking) {
        return "查询中...";
      }
      if (this.orderLoading) {
        return "生成订单中...";
      }
      return "我已支付";
    },
    goPayButtonText() {
      return this.orderLoading ? "生成订单中..." : "去支付";
    },
    qrExpired() {
      return (
        this.paymentStarted &&
        !!this.qrCodeImgUrl &&
        this.remainingSeconds <= 0
      );
    },
    payExpireText() {
      if (this.qrExpired) {
        return "二维码已过期,请刷新二维码";
      }
      const minutes = Math.floor(this.remainingSeconds / 60);
      const seconds = this.remainingSeconds % 60;
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")} 后二维码失效`;
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.resetPayState();
        this.loadPreview(true);
      } else {
        this.stopPolling();
        this.stopCountdown();
      }
    },
  },
  beforeDestroy() {
    this.stopPolling();
    this.stopCountdown();
  },
  methods: {
    resetPayState() {
      this.previewRequestId += 1;
      this.addSeats = 1;
      this.paymentMethod = "alipay";
      this.preview = null;
      this.previewLoading = false;
      this.orderLoading = false;
      this.paymentStarted = false;
      this.payChecking = false;
      this.qrCodeImgUrl = "";
      this.outTradeNo = "";
      this.remainingSeconds = PAY_EXPIRE_SECONDS;
      this.paySessions = {
        alipay: createEmptyPaySession(),
        wechat: createEmptyPaySession(),
      };
      this.pendingSuccessType = "";
      this.stopCountdown();
    },
    updateAddSeats(value) {
      const seats = this.normalizeAddSeats(value);
      if (seats === this.addSeats) {
        return;
      }
      this.addSeats = seats;
      this.loadPreview();
    },
    normalizeAddSeats(value) {
      return Math.min(
        this.maxAddSeats,
        Math.max(1, Math.floor(Number(value) || 1)),
      );
    },
    handleAddSeatsInput(event) {
      const input = event.target;
      const value = String(input.value || "").replace(/\D/g, "");
      if (!value) {
        input.value = "";
        return;
      }
      const seats = this.normalizeAddSeats(value);
      input.value = String(seats);
      this.updateAddSeats(seats);
    },
    handleAddSeatsBlur(event) {
      const seats = this.normalizeAddSeats(event.target.value);
      event.target.value = String(seats);
      this.updateAddSeats(seats);
    },
    handlePaymentMethodChange() {
      if (!this.preview || !this.paymentStarted) {
        return;
      }
      this.stopPolling();
      this.stopCountdown();
      const previousMethod = this.paymentMethod === "wechat" ? "alipay" : "wechat";
      this.$set(this.paySessions, previousMethod, createEmptyPaySession());
      this.createOrder();
    },
    handleGoPay() {
      this.paymentStarted = true;
      this.createOrder();
    },
    handleRefreshQr() {
      if (!this.qrExpired || this.orderLoading) {
        return;
      }
      this.stopPolling();
      this.createOrder();
    },
    handleCancel() {
      this.previewRequestId += 1;
      this.dialogVisible = false;
      this.$emit("close");
    },
    getCurrentPaySession() {
      return this.paySessions[this.paymentMethod] || createEmptyPaySession();
    },
    getSessionRemainingSeconds(session) {
      if (!session || !session.expireAt) {
        return 0;
      }
      return Math.max(0, Math.ceil((session.expireAt - Date.now()) / 1000));
    },
    applyPaySession(session) {
      this.qrCodeImgUrl = (session && session.qrCodeImgUrl) || "";
      this.outTradeNo = (session && session.outTradeNo) || "";
      this.remainingSeconds = this.getSessionRemainingSeconds(session);
    },
    saveCurrentPaySession(partial = {}) {
      const current = this.getCurrentPaySession();
      this.$set(this.paySessions, this.paymentMethod, {
        ...current,
        ...partial,
      });
    },
    resetCurrentCountdown() {
      const expireAt = Date.now() + PAY_EXPIRE_SECONDS * 1000;
      this.remainingSeconds = PAY_EXPIRE_SECONDS;
      this.saveCurrentPaySession({ expireAt });
      this.startCountdown();
    },
    startCountdown() {
      this.stopCountdown();
      this.tickCountdown();
      this.countdownTimerId = setInterval(() => {
        this.tickCountdown();
      }, 1000);
    },
    tickCountdown() {
      const session = this.getCurrentPaySession();
      this.remainingSeconds = this.getSessionRemainingSeconds(session);
      if (this.remainingSeconds <= 0) {
        this.stopCountdown();
        this.stopPolling();
      }
    },
    stopCountdown() {
      if (this.countdownTimerId) {
        clearInterval(this.countdownTimerId);
        this.countdownTimerId = null;
      }
    },
    startPolling() {
      this.stopPolling();
      if (!this.outTradeNo || this.remainingSeconds <= 0) {
        return;
      }
      this.pollTimerId = setInterval(() => {
        this.checkPayState("automaticPolling");
      }, 1500);
    },
    loadPreview(isopen = false) {
      const previewRequestId = this.previewRequestId + 1;
      this.previewRequestId = previewRequestId;
      this.stopPolling();
      this.stopCountdown();
      this.qrCodeImgUrl = "";
      this.outTradeNo = "";
      this.remainingSeconds = PAY_EXPIRE_SECONDS;
      this.paySessions = {
        alipay: createEmptyPaySession(),
        wechat: createEmptyPaySession(),
      };
      this.paymentStarted = false;
      this.previewLoading = true;

      this.$axios
        .post(
          `${this.$store.state.serverUrl}ytb/subscription/add-seats/preview`,
          this.buildAddSeatsPayload(),
        )
        .then((res) => {
          if (previewRequestId !== this.previewRequestId) {
            return;
          }
          if (!isApiSuccess(res.data.code)) {
            if (this.$message) {
              this.$message.error(res.data.message || "获取新增席位预览失败");
            }
            this.handleCancel();
            return;
          }

          this.preview = res.data.data || {};
          if(isopen) {
            this.unitCurrentMonthCredits = Number(this.preview.currentMonthCredits);
          }
        })
        .catch(() => {
          if (previewRequestId !== this.previewRequestId) {
            return;
          }
          if (this.$message) {
            this.$message.error("获取新增席位预览失败");
          }
          this.handleCancel();
        })
        .finally(() => {
          if (previewRequestId === this.previewRequestId) {
            this.previewLoading = false;
          }
        });
    },
    createOrder() {
      if (!this.preview) {
        return;
      }
      const requestMethod = this.paymentMethod;
      this.stopPolling();
      this.stopCountdown();
      this.qrCodeImgUrl = "";
      this.outTradeNo = "";
      this.remainingSeconds = PAY_EXPIRE_SECONDS;
      this.saveCurrentPaySession(createEmptyPaySession());
      this.orderLoading = true;

      this.$axios
        .post(
          `${this.$store.state.serverUrl}ytb/subscription/add-seats/pay/create/${requestMethod === "wechat" ? "微信" : "支付宝"}`,
          this.buildAddSeatsPayload(),
        )
        .then(async (res) => {
          if (requestMethod !== this.paymentMethod) {
            return;
          }
          if (!isApiSuccess(res.data.code)) {
            if (this.$message) {
              this.$message.error(res.data.message || "创建新增席位订单失败");
            }
            this.handleCancel();
            return;
          }

          const data = res.data.data || {};
          const qrSource = data.codeUrl || data.key;
          const tradeNo = data.outTradeNo || data.orderNo || data.key;
          if (!qrSource || !tradeNo) {
            if (this.$message) {
              this.$message.error("未获取到支付信息");
            }
            this.handleCancel();
            return;
          }

          let qrCodeImgUrl = "";
          try {
            qrCodeImgUrl = await QRCode.toDataURL(String(qrSource), {
              width: 220,
              margin: 1,
            });
          } catch (error) {
            if (this.$message) {
              this.$message.error("二维码生成失败");
            }
            this.handleCancel();
            return;
          }

          if (requestMethod !== this.paymentMethod) {
            return;
          }

          this.outTradeNo = tradeNo;
          this.qrCodeImgUrl = qrCodeImgUrl;
          this.saveCurrentPaySession({
            qrCodeImgUrl,
            outTradeNo: tradeNo,
          });
          this.resetCurrentCountdown();
          this.startPolling();
        })
        .catch(() => {
          if (requestMethod !== this.paymentMethod) {
            return;
          }
          if (this.$message) {
            this.$message.error("创建新增席位订单失败");
          }
          this.handleCancel();
        })
        .finally(() => {
          if (requestMethod === this.paymentMethod) {
            this.orderLoading = false;
          }
        });
    },
    handlePaid() {
      this.payChecking = true;
      this.checkPayState()
        .then((success) => {
          if (!success && this.$message) {
            this.$message.warning("暂未检测到支付成功，请完成扫码后再试");
          }
        })
        .finally(() => {
          this.payChecking = false;
        });
    },
    checkPayState(type) {
      if (!this.outTradeNo) {
        return Promise.resolve(false);
      }

      return this.$axios
        .get(`${this.$store.state.serverUrl}ytb/subscription/pay/state`, {
          params: {
            outTradeNo: this.outTradeNo,
            paymentType: this.getStatePaymentType(),
          },
          multipleCancel: true,
        })
        .then((res) => {
          if (isApiSuccess(res.data.code) && res.data.data === "SUCCESS") {
            this.handlePaySuccess(type);
            return true;
          }
          return false;
        })
        .catch(() => false);
    },
    getStatePaymentType() {
      return this.paymentMethod === "wechat" ? "微信" : "支付宝";
    },
    buildAddSeatsPayload() {
      const payload = {
        addSeats: this.addSeats,
      };
      if (this.normalizedPeriodType != null) {
        payload.periodType = this.normalizedPeriodType;
      }
      return payload;
    },
    handlePaySuccess(type) {
      this.stopPolling();
      this.stopCountdown();
      this.dialogVisible = false;
      this.pendingSuccessType = type || "";
      this.refreshPaySuccessData();
      this.payResultVisible = true;
    },
    finalizePaySuccess() {
      this.payResultVisible = false;
      this.$emit("success", {
        addSeats: this.addSeats,
        auto: this.pendingSuccessType === "automaticPolling",
        preview: this.preview,
      });
      this.pendingSuccessType = "";
    },
    refreshPaySuccessData() {
      this.$store.dispatch("fetchUserSubscription");
      this.refreshTeamInfo();
      bus.$emit("allPoints");
    },
    refreshTeamInfo() {
      const serverUrl = this.$store.state.serverUrl;
      this.$axios
        .get(`${serverUrl}ytb/user/client/team/overview`)
        .then((res) => {
          if (isApiSuccess(res.data.code)) {
            bus.$emit("teamOverviewUpdated", res.data.data || {});
          }
        })
        .catch(() => {});
      this.$axios
        .post(`${serverUrl}ytb/user/client/user/page`, {})
        .then((res) => {
          if (isApiSuccess(res.data.code)) {
            // 新结构 data 为树形数组
            bus.$emit("teamMembersUpdated", res.data.data || []);
          }
        })
        .catch(() => {});
    },
    stopPolling() {
      if (this.pollTimerId) {
        clearInterval(this.pollTimerId);
        this.pollTimerId = null;
      }
    },
    formatNumber(value) {
      return Number(value || 0).toLocaleString("zh-CN");
    },
  },
};
</script>

<style lang="less" scoped>
/* 尺寸按设计稿 px/14 转 rem；字号用 max(12PX, Nrem) 保证小屏不低于 12px */

.add-seats-overlay {
  position: fixed;
  inset: 0;
  z-index: 3100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.72);
  color: #f8fafc;
}

.add-seats-dialog {
  position: relative;
  display: grid;
  grid-template-columns: minmax(30rem, 1fr) 25.71429rem;
  width: min(54.28571rem, calc(100vw - 2.85714rem));
  min-height: 40rem;
  overflow: hidden;
  border: 1px solid rgba(80, 85, 112, 0.72);
  border-radius: 1rem;
  background: #10111b;
  box-shadow: 0 2.14286rem 5.71429rem rgba(0, 0, 0, 0.5);
}

.add-seats-close,
.add-seats-panel-close {
  position: absolute;
  width: 2rem;
  height: 2rem;
  padding: 0;
  border: none;
  background: transparent;
  color: #8b93a7;
  cursor: pointer;
  font-size: ~"max(12PX, 1.28571rem)";
  line-height: 2rem;
}

.add-seats-close {
  top: 1.14286rem;
  right: 1.14286rem;
  z-index: 3;
}

.add-seats-panel-close {
  top: 1.14286rem;
  right: 1.28571rem;
}

.add-seats-main {
  position: relative;
  padding: 2rem 2rem 1.71429rem;
  border-right: 1px solid rgba(72, 77, 105, 0.75);
  background: #12131f;
}

.add-seats-title {
  margin: 0;
  color: #ffffff;
  font-size: ~"max(12PX, 1.42857rem)";
  font-weight: 800;
  line-height: 2rem;
}

.add-seats-divider {
  height: 1px;
  margin: 1rem 0 1.14286rem;
  background: rgba(255, 255, 255, 0.08);
}

.add-seats-label,
.add-seats-count-head {
  margin: 0 0 0.57143rem;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";
}

.add-seats-plan-card {
  margin-bottom: 1.28571rem;
  padding: 1.28571rem 1.42857rem 1.14286rem;
  border: 1px solid #7c3aed;
  border-radius: 0.57143rem;
  background: rgba(31, 30, 55, 0.72);
  box-shadow: 0 0 0 1px rgba(124, 58, 237, 0.18);
}

.add-seats-plan-name {
  color: #ffffff;
  font-size: ~"max(12PX, 1.07143rem)";
  font-weight: 800;
}

.add-seats-plan-desc{
	margin: 0.42857rem 0 0;
  color: #fff;
  font-size: ~"max(12PX, 0.85714rem)";
	font-weight: 500;
}
.add-seats-plan-month {
  margin: 0.42857rem 0 0;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.85714rem)";
	// font-weight: 500;
}

.add-seats-plan-price {
  margin-top: 0.57143rem;
  color: #f8fafc;
  font-size: ~"max(12PX, 2rem)";
  font-weight: 900;
  line-height: 1;

  span {
    color: #8b93a7;
    font-size: ~"max(12PX, 0.85714rem)";
    font-weight: 500;
  }

  em {
    margin-left: 0.57143rem;
    color: #8b93a7;
    font-size: ~"max(12PX, 1rem)";
    font-style: normal;
    font-weight: 500;
    text-decoration: line-through;
  }
}

.add-seats-counter {
  display: inline-flex;
  align-items: center;
  gap: 1.14286rem;
  margin-bottom: 1.28571rem;

  button {
    width: 2.28571rem;
    height: 2.28571rem;
    border-radius: 0.57143rem;
    border: 1.5px solid #1e1e35;
    background: #15152a;;
    color: #e8e6f0;
    font-size: ~"max(12PX, 1.14286rem)";
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: inherit;
    transition: .15s;

  &:hover:not(:disabled) {
    border-color: #7c3aed;
  }

  &:disabled {
    color: rgba(255, 255, 255, 0.3);
    cursor: not-allowed;
  }
  }

  strong {
    min-width: 3.85714rem;
    color: #ffffff;
    font-size: ~"max(12PX, 1.14286rem)";
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.28571rem;

    input {
      width: 2.28571rem;
      padding: 0;
      border: none;
      outline: none;
      background: transparent;
      color: inherit;
      font: inherit;
      font-weight: inherit;
      text-align: center;
    }

    input:disabled {
      cursor: not-allowed;
    }
  }
}

.add-seats-summary {
  padding: 1.14286rem 1.28571rem;
  border-radius: 0.57143rem;
  background: rgba(20, 21, 39, 0.9);
}

.add-seats-summary-row,
.add-seats-pay-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.28571rem;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";
  line-height: 2rem;

  strong {
    color: #c6cce0;
    font-weight: 700;
  }
}

.add-seats-discount-row {
  strong {
    color: #fff;
  }
}

.add-seats-pay-row {
  margin-top: 0.57143rem;
  padding-top: 0.85714rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  color: #ffffff;
  font-size: ~"max(12PX, 1.07143rem)";

  strong {
    color: #ffc400;
    font-size: ~"max(12PX, 1.57143rem)";
    font-weight: 900;
  }
}

.add-seats-pay-amount-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.14286rem;

  em {
    color: #8b93a7;
    font-size: ~"max(12PX, 0.85714rem)";
    font-style: normal;
    text-decoration: line-through;
    line-height: 1.2;
  }
}

.add-seats-pay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3.85714rem 2.71429rem 2.42857rem;
  background: #10111b;
  text-align: center;
}

.add-seats-pay-amount-label {
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";
}

.add-seats-pay-amount {
  margin-top: 1.14286rem;
  color: #ffc400;
  font-size: ~"max(12PX, 2.14286rem)";
  font-weight: 900;
  line-height: 1.2;
}

.add-seats-pay-seats {
  margin-top: 1.28571rem;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";
}

.add-seats-go-pay-button {
  width: 13.57143rem;
  height: 2.85714rem;
  margin-top: 1.28571rem;
  border: none;
  border-radius: 0.42857rem;
  background: linear-gradient(90deg, #8b5cf6, #7c3aed);
  color: #ffffff;
  cursor: pointer;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 800;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.78;
  }
}

.add-seats-expire {
  min-height: 1.42857rem;
  margin-bottom: 0.85714rem;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";

  &.is-expired {
    color: #ff6b6b;
  }
}

.add-seats-qr {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12.71429rem;
  height: 12.71429rem;
  overflow: hidden;
  border-radius: 0.57143rem;
  background: #ffffff;

  &.is-clickable {
    cursor: pointer;
  }
}

.add-seats-qr-image {
  width: 12rem;
  height: 12rem;
}

.add-seats-qr-placeholder {
  color: #4b5563;
  font-size: ~"max(12PX, 0.92857rem)";
}

.add-seats-qr-expired {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.57143rem;
  padding: 1.14286rem;
  background: rgba(16, 17, 27, 0.72);
  color: #ffffff;
  font-size: ~"max(12PX, 0.92857rem)";
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  cursor: pointer;
  user-select: none;

  .el-icon-refresh {
    font-size: ~"max(12PX, 1.57143rem)";
    font-weight: 400;
  }
}

.add-seats-pay-title {
  margin-top: 0.85714rem;
  color: #ffffff;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 800;
}

.add-seats-methods {
  display: flex;
  gap: 1.28571rem;
  margin-top: 1rem;
}

.add-seats-method {
  display: inline-flex;
  align-items: center;
  gap: 0.42857rem;
  color: #c6cce0;
  cursor: pointer;
  font-size: ~"max(12PX, 0.92857rem)";

  input {
    accent-color: #7c3aed;
  }
}

.add-seats-paid-button {
  width: 13.57143rem;
  height: 2.85714rem;
  margin-top: 1rem;
  border: none;
  border-radius: 0.42857rem;
  background: linear-gradient(90deg, #8b5cf6, #7c3aed);
  color: #ffffff;
  cursor: pointer;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 800;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.78;
  }
}

.add-seats-agreement {
  margin: 0.57143rem 0 0;
  color: #6f778b;
  font-size: ~"max(12PX, 0.78571rem)";
}

@media (max-width: 760px) {
  .add-seats-dialog {
    grid-template-columns: 1fr;
    max-height: calc(100vh - 2.85714rem);
    overflow: auto;
  }

  .add-seats-main {
    border-right: none;
    border-bottom: 1px solid rgba(72, 77, 105, 0.75);
  }
}
</style>
